import axios from 'axios';
import { createBrowserHistory } from 'history';
import {LocalStorageService} from "./localStorageService.js";
import { apiEndpoints } from '../constants/apiEndpoints';
import { userService } from '../../store/middlewares/userService';
import { helper } from './helper.js';
const history = createBrowserHistory();

const baseURL = process.env.REACT_APP_API_URL;
// const baseURL = "https://ca99cd95.ngrok.io/";
// LocalstorageService
const localStorageService = LocalStorageService._getService();
// // axios.defaults.baseURL = url;
const mainInstance = axios.create({
    //   baseURL: config.target
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
//   crossDomain: true
});

const makeRequest = instance => (method, url, token, ...params) => {
    const authToken = localStorageService._getAccessToken();
    if (authToken) {
        axios.defaults.headers.common['Authorization'] = 'JWT ' + authToken;
    }
    if (!token) {
        delete axios.defaults.headers.common["Authorization"];
    }
    instance.interceptors.response.use(
        response => {
            return Promise.resolve(response);
        }, error => {
            const originalRequest = error.config;
            if (error && error.response && error?.response?.status === 401 && !originalRequest._retry && !helper.isEmpty(authToken)) {
                // clearLocalStorage();
                originalRequest._retry = true;
                const refreshToken = localStorageService._getRefreshToken();
                return axios.post(`${baseURL}` + apiEndpoints.JWT_REFRESH,
                    {
                        "refresh": refreshToken
                    })
                    .then(res => {
                        const response = res.data.data;
                        if (res.status === 200) {
                            localStorageService._setToken(response);
                            const authTokenRecieved = localStorage.getItem('token');
                            axios.defaults.headers.common['Authorization'] = 'JWT ' + authTokenRecieved;
                            originalRequest.headers['Authorization'] = 'JWT ' + authTokenRecieved;
                            // originalRequest.headers['authorization'] = 'JWT ' + authTokenRecieved;
                            return axios(originalRequest);
                        }else{
                            userService.clearLocalStorage();
                            history.push("/login");
                        }
                    }).catch(error => {
                        if(error?.response?.status === 401)
                        {
                            userService.clearLocalStorage();
                            history.push("/login");
                        }
                        else if (error?.response?.status === 500) {
                            history.push("/500");
                        } else if (error?.response?.status=== 404) {
                            history.push("/404");
                        }
                        return error.response;
                    });
            }
            else{
                return Promise.reject(error)
            }
        }
    );
    return instance[method](url, ...params);
};

const axiosRequest = (method, url, token) => (...params) => {
    return makeRequest(mainInstance)(method, url, token, ...params);
}
export default axiosRequest